import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

function ListadoInventariosTotal() {
  const { user } = useContext(AuthContext);
  const URL_INVENTARIOS = `${process.env.REACT_APP_URL_INVENTARIOS}`;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  const URL_COLECCIONES = process.env.REACT_APP_URL_COLECCIONES;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  const [lineas, setLineas] = useState([]);
  const [selectedLineaFiltro, setSelectedLineaFiltro] = useState("");
  const [selectedTipoFiltro, setSelectedTipoFiltro] = useState("");
  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");
  const [familias, setFamilias] = useState([]);
  const [selectedFamiliaFiltro, setSelectedFamiliaFiltro] = useState("");
  const [colecciones, setColecciones] = useState([]);
  const [selectedColeccion, setSelectedColeccion] = useState("");
  const [selectedAno, setSelectedAno] = useState("");
  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");
  const [activo, setActivo] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [totalTotal, setTotalTotal] = useState(0);

  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [ocultarCantidad0, setOcultarCantidad0] = useState(false);
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 5000000;

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(12), (val, index) => index + year);

  useEffect(() => {
    axios
      .get(`${URL_INVENTARIOS}Acumulado`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => {
        const allInventarios = response.data;
        // Agrupar por idArticulo (sumando cantidad de todos los almacenes).
        const map = new Map();
        allInventarios.forEach((a) => {
          const idArt = String(a.idArticulo);
          const prev = map.get(idArt);
          if (prev) {
            prev.cantidad += parseFloat(a.cantidad) || 0;
          } else {
            map.set(idArt, {
              idArticulo: a.idArticulo,
              activo: a.activo,
              codigo: a.codigo,
              codigoCliente: a.codigoCliente,
              nombre: a.nombre,
              venta: a.venta,
              venta2: a.venta2 || 0,
              venta3: a.venta3 || 0,
              venta4: a.venta4 || 0,
              piezasPorCaja: a.piezasPorCaja,
              linea: a.linea,
              idLinea: a.idLinea,
              marca: a.marca,
              idMarca: a.idMarca,
              familia: a.familia,
              idFamilia: a.idFamilia,
              coleccion: a.coleccion,
              idColeccion: a.idColeccion,
              ano: a.ano,
              tipo: a.tipo,
              urlFoto: a.urlFoto,
              cantidad: parseFloat(a.cantidad) || 0,
            });
          }
        });
        const dataFinal = Array.from(map.values());
        setComments(dataFinal);
        const TCan = dataFinal.reduce((t, c) => t + (parseFloat(c.cantidad) || 0), 0);
        setTotalTotal(TCan);
      })
      .catch((err) => console.log(err));

    axios
      .get(URL_LINEAS, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((r) => setLineas(r.data))
      .catch((err) => console.log(err));

    axios
      .get(URL_MARCAS, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((r) => setMarcas(r.data))
      .catch((err) => console.log(err));

    axios
      .get(URL_FAMILIAS, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((r) => setFamilias(r.data))
      .catch((err) => console.log(err));

    axios
      .get(URL_COLECCIONES, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((r) => setColecciones(r.data))
      .catch((err) => console.log(err));

    axios
      .get(URL_ARTICULOS, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((r) => setArticulos(r.data))
      .catch((err) => console.log(err));
  }, []);

  async function PromptListaParaPDF() {
    const { value: listas } = await Swal.fire({
      title: "Que listas de precios quieres?",
      html: `
        <div style="text-align: left; padding: 0 20px;">
          <label style="display:block; margin: 8px 0;"><input type="checkbox" id="swal-l1" checked /> Lista Milano</label>
          <label style="display:block; margin: 8px 0;"><input type="checkbox" id="swal-l2" /> Lista 2</label>
          <label style="display:block; margin: 8px 0;"><input type="checkbox" id="swal-l3" /> Lista 3</label>
          <label style="display:block; margin: 8px 0;"><input type="checkbox" id="swal-l4" /> Lista 4</label>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Generar PDF",
      cancelButtonText: "Cancelar",
      preConfirm: () => {
        const selected = [];
        if (document.getElementById("swal-l1").checked) selected.push(1);
        if (document.getElementById("swal-l2").checked) selected.push(2);
        if (document.getElementById("swal-l3").checked) selected.push(3);
        if (document.getElementById("swal-l4").checked) selected.push(4);
        if (selected.length === 0) {
          Swal.showValidationMessage("Selecciona al menos una lista");
          return false;
        }
        return selected;
      },
    });
    if (listas && listas.length) PDFTabla(listas);
  }

  function PDFTabla(listas = [1]) {
    const ventaKey = (n) => `venta${n === 1 ? "" : n}`;
    let total_general = 0;
    const totalDinero = listas.map(() => 0);

    const data = comments
      .filter(
        (comment) =>
          String(comment.codigo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.codigoCliente ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.tipo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.coleccion ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.ano ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.cantidad ?? "").includes(search)
      )
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => {
        if (
          (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
          (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
          (selectedTipoFiltro == 0 || selectedTipoFiltro == a.tipo) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) &&
          (selectedFamiliaFiltro == 0 || selectedFamiliaFiltro == a.idFamilia) &&
          (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
          (selectedAno == 0 || selectedAno == a.ano) &&
          (activo == 0 || activo == a.activo) &&
          (!ocultarCantidad0 || parseFloat(a.cantidad) > 0)
        ) {
          total_general += parseFloat(a.cantidad) || 0;
          listas.forEach((n, idx) => {
            totalDinero[idx] +=
              (parseFloat(a.cantidad) || 0) * (parseFloat(a[ventaKey(n)]) || 0);
          });
          const preciosCols = listas.map((n) =>
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(parseFloat(a[ventaKey(n)]) || 0)
          );
          return [
            a.codigo,
            a.codigoCliente,
            a.nombre,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            ...preciosCols,
          ];
        }
      });
    const dataPDFLimpia = Object.values(data).filter((el) => el != null);
    const doc = new jsPDF("landscape", "mm", "a4", true);
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 30);
    const listasTexto = listas.map((n) => `Lista ${n}`).join(", ");
    doc.text(`Inventario Total - ${listasTexto}`, 20, 40);
    doc.setFontSize(8);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Codigo Cliente",
          "Nombre",
          "Cantidad",
          ...listas.map((n) => `Lista ${n}`),
        ],
      ],
      body: dataPDFLimpia,
      headStyles: { fillColor: ["#f28029"], lineWidth: 0 },
      footStyles: { fillColor: ["#f28029"] },
      theme: "grid",
      startY: 45,
      foot: [
        [
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US").format(total_general),
          ...totalDinero.map((t) =>
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(t)
          ),
        ],
      ],
      showFoot: "lastPage",
      styles: { fontSize: 8, cellPadding: 3 },
    });
    const blobUrl = URL.createObjectURL(doc.output("blob"));
    window.open(blobUrl, "_blank");
  }

  function excel() {
    const dataExcel = comments
      .filter(
        (comment) =>
          String(comment.codigo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.codigoCliente ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.tipo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.coleccion ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.ano ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.cantidad ?? "").includes(search)
      )
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => {
        if (
          (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
          (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
          (selectedTipoFiltro == 0 || selectedTipoFiltro == a.tipo) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) &&
          (selectedFamiliaFiltro == 0 || selectedFamiliaFiltro == a.idFamilia) &&
          (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
          (selectedAno == 0 || selectedAno == a.ano) &&
          (activo == 0 || activo == a.activo) &&
          (!ocultarCantidad0 || parseFloat(a.cantidad) > 0)
        ) {
          return {
            Codigo: a.codigo,
            CodigoCliente: a.codigoCliente,
            Nombre: a.nombre,
            Cantidad: a.cantidad,
            Lista1: a.venta,
            Lista2: a.venta2,
            Lista3: a.venta3,
            Lista4: a.venta4,
          };
        }
      });
    const dataExcelLimpia = Object.values(dataExcel).filter((el) => el != null);
    const option = {
      fileName: "InventariosTotal",
      datas: [
        {
          sheetData: dataExcelLimpia,
          sheetName: "InventariosTotal",
          sheetFilter: [
            "Codigo",
            "CodigoCliente",
            "Nombre",
            "Cantidad",
            "Lista1",
            "Lista2",
            "Lista3",
            "Lista4",
          ],
          sheetHeader: [
            "Codigo",
            "Codigo Cliente",
            "Nombre",
            "Cantidad",
            "Lista Milano",
            "Lista 2",
            "Lista 3",
            "Lista 4",
          ],
        },
      ],
    };
    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    PDFTabla([1]);
    // El usuario puede usar el PDF abierto en pestana para guardar/enviar.
    // Para simplificar, este boton replica el PDF.
  }

  const headers = [
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Codigo Cliente", field: "codigoCliente", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Lista Milano", field: "venta", sortable: true },
    { name: "Lista 2", field: "venta2", sortable: true },
    { name: "Lista 3", field: "venta3", sortable: true },
    { name: "Lista 4", field: "venta4", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          String(comment.codigo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.codigoCliente ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.tipo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.coleccion ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.ano ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.cantidad ?? "").includes(search) ||
          String(comment.venta ?? "").includes(search) ||
          String(comment.piezasPorCaja ?? "").includes(search)
      );
    }
    if (selectedLineaFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idLinea && e.idLinea.includes(selectedLineaFiltro)
      );
    }
    if (selectedTipoFiltro) {
      computedComments = computedComments.filter((e) =>
        e.tipo && e.tipo.includes(selectedTipoFiltro)
      );
    }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        String(e.activo ?? "").includes(activo)
      );
    }
    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        e.idMarca && e.idMarca.includes(selectedMarca)
      );
    }
    if (selectedArticulo) {
      computedComments = computedComments.filter((e) =>
        e.idArticulo && e.idArticulo.includes(selectedArticulo)
      );
    }
    if (selectedFamiliaFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idFamilia && e.idFamilia.includes(selectedFamiliaFiltro)
      );
    }
    if (selectedColeccion) {
      computedComments = computedComments.filter((e) =>
        e.idColeccion && e.idColeccion.includes(selectedColeccion)
      );
    }
    if (selectedAno) {
      computedComments = computedComments.filter((e) =>
        String(e.ano ?? "").includes(selectedAno)
      );
    }
    if (ocultarCantidad0) {
      computedComments = computedComments.filter((e) => parseFloat(e.cantidad) > 0);
    }

    setTotalItems(computedComments.length);

    const numericFields = ["cantidad", "piezasPorCaja", "venta", "venta2", "venta3", "venta4"];
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      if (numericFields.includes(sorting.field)) {
        computedComments = computedComments.sort(
          (a, b) =>
            reversed *
            ((parseFloat(a[sorting.field]) || 0) -
              (parseFloat(b[sorting.field]) || 0))
        );
      } else {
        computedComments = computedComments.sort(
          (a, b) =>
            reversed *
            String(a[sorting.field] ?? "").localeCompare(String(b[sorting.field] ?? ""))
        );
      }
    }

    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedArticulo,
    activo,
    selectedLineaFiltro,
    selectedTipoFiltro,
    selectedMarca,
    selectedFamiliaFiltro,
    selectedColeccion,
    selectedAno,
    ocultarCantidad0,
  ]);

  function limpiarSearch() {
    setSearch("");
    setSelectedLineaFiltro("");
    setSelectedTipoFiltro("");
    setSelectedMarca("");
    setSelectedFamiliaFiltro("");
    setSelectedColeccion("");
    setSelectedAno("");
    setSelectedArticulo("");
    setActivo("");
  }

  let total = 0;
  return (
    <>
      <Header />
      <br />
      <br />
      {user.inventarios ? (
        <div className="card col-12">
          <Row>
            <Col sm={8}>
              <Button
                size="sm"
                href="/MenuInventarios"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button size="sm" className="btn" color="danger" onClick={PromptListaParaPDF}>
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button size="sm" className="btn" onClick={toggleMail} color="info">
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button size="sm" className="btn" color="primary" onClick={excel}>
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>

          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Inventarios Total</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => setMailTo(e.target.value)}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Generar PDF
              </Button>
            </ModalFooter>
          </Modal>

          <h3 align="center">Inventario Total</h3>
          <div className="row">
            <div className="col-md-11 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
            <div className="col-md-1 flex-row-reverse">
              <Button size="sm" className="btn" color="info" onClick={limpiarSearch}>
                Limpiar
              </Button>
            </div>
            <div
              className="col-md-12 d-flex flex-row-reverse"
              style={{ paddingRight: 15 }}
            >
              <label style={{ cursor: "pointer", marginTop: 8 }}>
                <input
                  type="checkbox"
                  checked={ocultarCantidad0}
                  onChange={(e) => {
                    setOcultarCantidad0(e.target.checked);
                    setCurrentPage(1);
                  }}
                />
                {" "}Ocultar cantidad 0
              </label>
            </div>
          </div>

          <Table
            size="sm"
            striped
            borderless
            className="table-responsive-xl"
          >
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArticulo}
                  onChange={(e) => {
                    setSelectedArticulo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {articulos
                    .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                    .map((a) => (
                      <option value={a._id}>
                        {a.codigo}
                      </option>
                    ))}
                </Input>
              </td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedTipoFiltro}
                  onChange={(e) => {
                    setSelectedTipoFiltro(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona Tipo</option>
                  <option value="Importacion">Importacion</option>
                  <option value="Nacional">Nacional</option>
                </Input>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
           {/* <tr>
              <td style={{ paddingTop: "0px" }} colSpan={2}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedLineaFiltro}
                  onChange={(e) => {
                    setSelectedLineaFiltro(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Linea</option>
                  {lineas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => (
                      <option value={a._id}>{a.name}</option>
                    ))}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedMarca}
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Marca</option>
                  {marcas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => (
                      <option value={a._id}>{a.name}</option>
                    ))}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedFamiliaFiltro}
                  onChange={(e) => {
                    setSelectedFamiliaFiltro(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Familia</option>
                  {familias
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => (
                      <option value={a._id}>{a.name}</option>
                    ))}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedColeccion}
                  onChange={(e) => {
                    setSelectedColeccion(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Coleccion</option>
                  {colecciones
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => (
                      <option value={a._id}>{a.name}</option>
                    ))}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedAno}
                  onChange={(e) => {
                    setSelectedAno(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Año</option>
                  {years.map((a) => (
                    <option value={a}>{a}</option>
                  ))}
                </Input>
              </td>
              <td></td>
              <td></td>
            </tr> */}
            <tbody>
              {commentsData.map((a) => {
                total = total + parseFloat(a.cantidad);
                return (
                  <tr>
                    <td>{a.codigo}</td>
                    <td>{a.codigoCliente}</td>
                    <td>{a.nombre}</td>
                    <td>
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(a.venta || 0)}
                    </td>
                    <td>
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(a.venta2 || 0)}
                    </td>
                    <td>
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(a.venta3 || 0)}
                    </td>
                    <td>
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(a.venta4 || 0)}
                    </td>
                    <td>{new Intl.NumberFormat("en-US").format(a.cantidad)}</td>
                  </tr>
                );
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(total)}
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL GENERAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalTotal)}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      ) : undefined}

      {loader}
    </>
  );
}

export default ListadoInventariosTotal;
